// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"59dbf81f","596":"59dbf81f"}[chunkId] + ".chunk.css";
};